const DATE_TO_COMPARE = 'dateToCompare'
const DRAG_ITEM_LIST = 'dragged-item-list'
const DRAGGED_ITEM_TABLE = 'dragged-item-table'
const PILES_SELECTED_YEAR = 'piles-selected-year'

export default { DATE_TO_COMPARE, DRAGGED_ITEM_TABLE, DRAG_ITEM_LIST, PILES_SELECTED_YEAR }
